import { from as observableFrom, Observable, tap, catchError } from 'rxjs';
import { Injectable } from '@angular/core';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { Command, CommandBase, MultiselectCommand } from '../../../core/model/command';
import { leaseAgreementCommand, LeaseAgreementMultiselectCommand } from '../../command/lease-agreement.command';
import { Router } from '@angular/router';
import { ComponentMessageDispatcher } from '../../../core/service/component-message-dispather.service';
import { Location } from '@angular/common';
import { rentalObjectCommand, RentalObjectMultiselectCommand } from '../../command/rental-object.command';
import { feeChangeCommand } from '../../command/fee-change.command';
import { FeeChangeService } from '../data/fee-change.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { MessageService } from '../../../core/service/message.service';

@Injectable()
export class FeeChangeRevertCommandHandler implements ICommandHandler {
  constructor(
    private _messageService: MessageService,
    private _feeChangeService: FeeChangeService,
    private _navigationService: NavigationService
  ) {}

  canExecute(command: CommandBase): boolean {
    if (command instanceof Command) {
      return command.id === feeChangeCommand.revert;
    }
    return false;
  }

  execute(command: Command): Observable<void> {
    return this._feeChangeService.revert(command.context.id).pipe(
      tap(x => this._navigationService.reloadCurrentRoute()),
      catchError(err => {
        this._messageService.showError(err);
        throw err;
      })
    );
  }
}
